export default {
  recurring: {
    id: 'summary_recurring_payment_info',
    defaultMessage:
      'Only the first round of recurring payments to Back Market is included in your total today.',
  },
}
